<img
  [style.width]="imageWidth ? imageWidth : '100%'"
  [src]="'assets/images/ui/icons/life-chances/' + lifeChance + '.png'"
  alt="" />
